module.exports = global["$"] = require("-!/Users/stefanschmidt/Entwicklung/plentySyncs/48470/242/Phywe/node_modules/expose-loader/index.js?jQuery!./jquery.js");